import Vue from "vue";
import VueRouter from "vue-router";

const Index = () => import("views/Index/Index.vue");


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);

// console.log(hotelname);
const routes = [
 
 
  {
    path: "",
    redirect: "/index",
    beforeEnter: (to, from, next) => {
      // document.title =  `酒店介绍 `
      next();
    }
  },
  {
    path: "/index",
    component: Index,
    meta: {
      title: `酒店介绍 `
    },
    beforeEnter: (to, from, next) => {
   
     
      // document.title = `Booking - ${appName}`;
      //// document.title = to.meta.title;
      next();
    }
  },{
    path: "/booking",
    component: () => import("views/Booking/Booking.vue"),
    meta: {
      // title: `酒店预订 `
    },
    beforeEnter: (to, from, next) => {
      //// document.title = to.meta.title;
      next();
    }
  },
  {
    path: "/gallery",
    component: () => import("views/Gallery/Gallery.vue"),
    meta: {
      title: `酒店图片 `
    },
    beforeEnter: (to, from, next) => {
      //// document.title = to.meta.title;
      next();
    }
  },
  {
    path: "/services",
    component: () => import("views/Services/Services.vue"),
    meta: {
      title:`酒店服务 `
    },
    beforeEnter: (to, from, next) => {
      //// document.title = to.meta.title;
      next();
    }
  },
  {
    path: "/conference",
    component: () => import("views/Conference/Conference.vue"),
    meta: {
      // title: `酒店会议 `
    },
    beforeEnter: (to, from, next) => {
     // document.title = to.meta.title;
      next();
    }
  },
  {
    path: "/reviews",
    component: () => import("views/Reviews/Reviews.vue"),
    meta: {
      // title: `酒店会议预定 `
    },
    beforeEnter: (to, from, next) => {
     // document.title = to.meta.title;
      next();
    }
  },
  {
    path: "/map",
    component: () => import("views/Map/Map.vue"),
    meta: {
      title: `酒店地图 `
    },
    beforeEnter: (to, from, next) => {
     // document.title = to.meta.title; 
      next();
    }
  },
  {
    path: "/Order",
    component: () => import("views/Order/Order.vue"),
    meta: {
      title: `酒店订单 `
    },
    beforeEnter: (to, from, next) => {
     // document.title = to.meta.title; 
      next();
    }
  },
  {
    path: "/OrderDetail",
    component: () => import("views/OrderDetail/OrderDetail.vue"),
    meta: {
      title: `酒店订单详情 `
    },
    beforeEnter: (to, from, next) => {
     // document.title = to.meta.title; 
      next();
    }
  },
  {
    path: "/Pay",
    component: () => import("views/Pay/Pay.vue"),
    meta: {
      title:`酒店支付 `
    },
    beforeEnter: (to, from, next) => {
     // document.title = to.meta.title; 
      next();
    }
  },
  {
    path: "/Nopage",
    component: () => import("views/Nopage/Nopage.vue"),
    meta: {
      title:`404页面 `
    },
    beforeEnter: (to, from, next) => {
     // document.title = to.meta.title; 
      next();
    }
  }
  
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
